import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { AlertCircle } from 'lucide-react';
export function StickyUrgencyBar() {
  const {
    offerState,
    formattedTime,
    currentPrice
  } = useCountdown();
  if (offerState === 'EXPIRED') return null;
  return <div className="sticky top-0 z-[999] w-full bg-terracota text-white py-2 px-4 shadow-md" data-id="element-320">
      <div className="max-w-4xl mx-auto flex items-center justify-center text-center space-x-2" data-id="element-321">
        <AlertCircle className="w-5 h-5 animate-pulse flex-shrink-0" data-id="element-322" />
        <p className="text-sm md:text-base font-inter font-semibold" data-id="element-323">
          {offerState === 'LAUNCH' ? <>
              🚨 Oferta expira en:{' '}
              <span className="font-mono bg-white/20 px-2 py-0.5 rounded mx-1" data-id="element-324">
                {formattedTime}
              </span>{' '}
              — Después sube a $29 USD
            </> : <>
              ⚡ SEGUNDA OPORTUNIDAD:{' '}
              <span className="font-mono bg-white/20 px-2 py-0.5 rounded mx-1" data-id="element-325">
                {formattedTime}
              </span>{' '}
              para obtenerlo a ${currentPrice} USD
            </>}
        </p>
      </div>
    </div>;
}